import $ from "jquery/dist/jquery";

$(() => {
  $(".recipe-filters").on("change", ".recipe-filter", function (e) {
    const recipes = $(e.delegateTarget);
    const targetSelector = recipes.data("target");
    const target = $(targetSelector);

    let ctg_ids = [];
    recipes.find(".recipe-filter:checked").each(function () {
      ctg_ids.push($(this).val());
    });

    $.ajax({
      url: window.location.pathname,
      method: "GET",
      data: {
        recipe_categories: ctg_ids.join(","),
      },
    })
      .done((data) => {
        target.html($(data).find(targetSelector).html());
      })
      .fail(() => {
        window.location.search = `?recipe_categories=${ctg_ids.join(",")}`;
      });
  });
});
